import { useQuery } from "@tanstack/react-query";
import axiosAuth from "../../axiosAuth";
import { SCHOOL_LAB_RESOURCES_BY_SCHOOL_ID } from "../apiRoutes";

export interface LabResourceItemApi {
  _id: string;
  schoolId: string;
  profile_id: string;
  createdBy?: string;
  lastUpdatedBy?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface LabResourceListResponse {
  data?: LabResourceItemApi[];
}

export const useGetLabResourcesBySchoolIdQuery = (
  schoolId: string,
  options?: { enabled?: boolean }
) => {
  return useQuery({
    queryKey: ["schoolLabResource", schoolId],
    enabled: Boolean(schoolId) && (options?.enabled ?? true),
    queryFn: async () => {
      const res = await axiosAuth.get<LabResourceListResponse>(
        `${SCHOOL_LAB_RESOURCES_BY_SCHOOL_ID}${schoolId}/`
      );
      return res.data;
    },
  });
};
